<div class="orders py-4">
  <header class="orders-header has-border align-items-center d-flex pb-2 mb-4">
    <h1 class="m-0">W9/ACH Document</h1>
  </header>

  <div class="nav nav-tabs mb-3">
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTabIndex() === 0"
      (click)="toggleTab(0)">
      W-9
    </button>
    <button
      type="button"
      class="nav-link"
      [class.active]="activeTabIndex() === 1"
      (click)="toggleTab(1)">
      ACH
    </button>
  </div>

  <div *ngIf="activeTabIndex() === 0" class="card border-0 shadow-sm mt-3">
    <div class="card-body p-4">
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
        <div>
          <p class="mb-1 fw-semibold text-uppercase small text-muted">
            Current document
          </p>

          <a
            *ngIf="
              currentDocumentUrl() &&
              currentFileName() !== 'No W-9 document uploaded'
            "
            class="d-inline-flex align-items-center gap-2 link text-decoration-underline fw-medium"
            [href]="currentDocumentUrl()"
            target="_blank"
            rel="noopener noreferrer"
            [title]="currentFileName()">
            {{ currentFileName() }}
          </a>

          <span
            *ngIf="
              !currentDocumentUrl() ||
              currentFileName() === 'No W-9 document uploaded'
            "
            class="sub-text fw-medium">
            {{ currentFileName() }}
          </span>
        </div>

        <div class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="!currentDocumentUrl() || isUploading()"
            (click)="downloadDocument()">
            Download
          </button>
        </div>
      </div>

      <div class="row g-4 align-items-start">
        <div class="col-12 col-md-8">
          @if (
            currentDocumentUrl() &&
            currentFileName() !== "No W-9 document uploaded"
          ) {
            <div class="alert alert-light border mb-3" role="status">
              {{ lastUpdatedLabel() }}
            </div>

            <ngx-extended-pdf-viewer
              [src]="currentDocumentUrl()"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [filenameForDownload]="currentFileName()"
              height="70vh">
            </ngx-extended-pdf-viewer>
          } @else {
            <div
              class="d-flex flex-column align-items-center justify-content-center text-center gap-2 p-4 rounded-4 border bg-light"
              role="status">
              <span class="no-data-image" aria-hidden="true"></span>
              <h2 class="h5 fw-semibold mb-0 mt-2 text-dark">
                {{ currentFileName() }}
              </h2>
              <p class="text-dark mb-0">
                {{
                  isUploading()
                    ? lastUpdatedLabel()
                    : "Upload a PDF using the panel to get started."
                }}
              </p>
            </div>
          }
        </div>
        <div class="col-12 col-md-4">
          <div
            class="border border-2 border-dashed rounded-3 bg-light p-4 text-center cursor-pointer"
            jniGlobalFileDrop
            [acceptedTypes]="['pdf']"
            [maxFileSize]="30"
            [maxFiles]="1"
            [disabled]="isUploading()"
            (filesDropped)="onW9FilesDropped($event)"
            (filesRejected)="onW9FilesRejected($event)"
            (click)="triggerFilePicker()"
            title="Drag and drop a PDF file here or click to choose a file">
            <div
              class="d-flex flex-column align-items-center justify-content-center gap-2">
              <i class="pi pi-cloud-upload fs-1 text-primary"></i>
              <p class="text-dark small mb-1">
                Upload a replacement PDF for the active ACH document.
              </p>
              <div class="fw-semibold">Drag & drop W-9 PDF here</div>
              <div class="text-dark small">or click to choose a file</div>
              <button
                type="button"
                class="btn btn-primary mt-2"
                [disabled]="isUploading()">
                {{ isUploading() ? "Uploading..." : "Choose PDF" }}
              </button>
            </div>
          </div>

          <input
            #w9FileInput
            type="file"
            accept="application/pdf"
            class="d-none"
            (change)="onFileSelected($event)"
            [disabled]="isUploading()" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="activeTabIndex() === 1" class="card border-0 shadow-sm mt-3">
    <div class="card-body p-4">
      <div
        class="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
        <div>
          <p class="mb-1 fw-semibold text-uppercase small text-muted">
            Current document
          </p>

          <a
            *ngIf="
              currentAchDocumentUrl() &&
              currentAchFileName() !== 'No ACH document uploaded'
            "
            class="d-inline-flex align-items-center gap-2 link text-decoration-underline fw-medium"
            [href]="currentAchDocumentUrl()"
            target="_blank"
            rel="noopener noreferrer"
            [title]="currentAchFileName()">
            {{ currentAchFileName() }}
          </a>

          <span
            *ngIf="
              !currentAchDocumentUrl() ||
              currentAchFileName() === 'No ACH document uploaded'
            "
            class="sub-text fw-medium">
            {{ currentAchFileName() }}
          </span>
        </div>

        <div class="d-flex gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="!currentAchDocumentUrl() || isAchUploading()"
            (click)="downloadAchDocument()">
            Download
          </button>
        </div>
      </div>

      <div class="row g-4 align-items-start">
        <div class="col-12 col-md-8">
          @if (
            currentAchDocumentUrl() &&
            currentAchFileName() !== "No ACH document uploaded"
          ) {
            <div class="alert alert-light border mb-3" role="status">
              {{ achLastUpdatedLabel() }}
            </div>

            <ngx-extended-pdf-viewer
              [src]="currentAchDocumentUrl()"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showPresentationModeButton]="true"
              [filenameForDownload]="currentAchFileName()"
              height="70vh">
            </ngx-extended-pdf-viewer>
          } @else {
            <div
              class="d-flex flex-column align-items-center justify-content-center text-center gap-2 p-4 rounded-4 border bg-light"
              role="status">
              <span class="no-data-image" aria-hidden="true"></span>
              <h2 class="h5 fw-semibold mb-0 mt-2 text-dark">
                {{ currentAchFileName() }}
              </h2>
              <p class="mb-0 text-dark">
                {{
                  isAchUploading()
                    ? achLastUpdatedLabel()
                    : "Upload a PDF using the panel to get started."
                }}
              </p>
            </div>
          }
        </div>
        <div class="col-12 col-md-4">
          <div
            class="border border-2 border-dashed rounded-3 bg-light p-4 text-center cursor-pointer"
            jniGlobalFileDrop
            [acceptedTypes]="['pdf']"
            [maxFileSize]="30"
            [maxFiles]="1"
            [disabled]="isAchUploading()"
            (filesDropped)="onAchFilesDropped($event)"
            (filesRejected)="onAchFilesRejected($event)"
            (click)="triggerAchFilePicker()"
            title="Drag and drop a PDF file here or click to choose a file">
            <div
              class="d-flex flex-column align-items-center justify-content-center gap-2">
              <i class="pi pi-cloud-upload fs-1 text-primary"></i>
              <p class="text-dark small mb-1">
                Upload a replacement PDF for the active ACH document.
              </p>
              <div class="fw-semibold">Drag & drop ACH PDF here</div>
              <div class="text-dark small">or click to choose a file</div>
              <button
                type="button"
                class="btn btn-primary mt-2"
                [disabled]="isAchUploading()">
                {{ isAchUploading() ? "Uploading..." : "Choose PDF" }}
              </button>
            </div>
          </div>

          <input
            #achFileInput
            type="file"
            accept="application/pdf"
            class="d-none"
            (change)="onAchFileSelected($event)"
            [disabled]="isAchUploading()" />
        </div>
      </div>
    </div>
  </div>
</div>
